module.exports = __webpack_public_path__ + "static/media/sg13cr93.3c2cb49b.png";